import React from 'react';
import PillarMaterialsSection from '../portal/PillarMaterialsSection';

/**
 * Portal Operations ▸ Materials tab. Sections and templates are edited from
 * CRM → Templates → Operations Materials (templatesStructures/operations +
 * templatesCollections docs with pillar 'Operations').
 */
const OperationsMaterialsTab = () => (
  <PillarMaterialsSection
    standalone
    pillar="Operations"
    structureId="operations"
    idPrefix="operations-material"
    emptyText="Operations materials are on the way — check back soon."
  />
);

export default OperationsMaterialsTab;
